import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { useAppDispatch } from '../../../../../../app/store';
import { writeoffApi } from '../../../../../../services/WriteoffService';
import { WriteoffWorklistView } from '../../../../../../services/WriteoffService/types/writeoffWorklistTypes';

/**
 * Hook for handling writeoff navigation from my approvals.
 */
export function useMyApprovalsNavigation(company: string, center: string) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const navigateToWriteoff = useCallback(
    (writeoffId: string) => {
      dispatch(writeoffApi.util.invalidateTags(['Writeoff']));
      navigate(
        `/writeoffs/edit?company=${encodeURIComponent(company)}&center=${encodeURIComponent(center)}&id=${encodeURIComponent(writeoffId)}`
      );
    },
    [navigate, dispatch, company, center]
  );

  const handleRowSelected = useCallback(
    (args: any) => {
      const selectedItem = args.data as WriteoffWorklistView;
      if (selectedItem?.writeoffId) {
        navigateToWriteoff(selectedItem.writeoffId);
      }
    },
    [navigateToWriteoff]
  );

  return { navigateToWriteoff, handleRowSelected };
}
